import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CAREERS_DATA } from './careers.model';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';
import { MatDialog } from '@angular/material/dialog';
import { CareerFormComponent } from '../../../Components/career-form/career-form.component';

@AutoUnsubscribe()
@Component({
  selector: 'app-careers',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './careers.component.html',
  styleUrl: './careers.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CareersComponent extends BaseComponent {
  public careersIntro = {
    title: CAREERS_DATA.title[this.language],
    brief: CAREERS_DATA.description[this.language],
    image: CAREERS_DATA.image,
  };
  public careersData = CAREERS_DATA.jobs.map((item) => {
    {
      return {
        title: item.title[this.language],
        description: item.description[this.language],
        link: item.link,
      };
    }
  });

  constructor(
    override readonly schoolApiService: SchoolApiService,
    private dialog: MatDialog,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }

  generalApply(): void {
    this.dialog.open(CareerFormComponent, {
      width: '95vw',
      maxWidth: '500px',
      height: 'auto',
      maxHeight: '100vh',
      panelClass: 'responsive-dialog',
    });
  }
}
